import React from 'react';
import AppContent from './AppContent';
import AppControls from './AppControls';
import { compose } from 'redux';
import { connect } from 'react-redux';
import AppMessageBar from '../common/AppMessageBar';

const AppWrapper = ({ children, authenticated, userDataLoaded, requestResult }) => (
  <>
    <AppControls controlsVisible={!!authenticated && userDataLoaded} />
    <AppContent controlsVisible={!!authenticated && userDataLoaded}>
      {children}
    </AppContent>
    <AppMessageBar status={requestResult} />
  </>
);

const decorate = compose(
  connect(
    store => ({
      authenticated: store.auth.authenticated,
      userDataLoaded: store.user.userDataLoaded,
      requestResult: store.api.requestResult,
    }),
    null,
  ),
);

export default decorate(AppWrapper);